module.exports = __webpack_public_path__ + "img/logo-blue.3a2a8bdf.png";